export interface WebGL2Status {
  ok: boolean;
  message: string;
  vendor?: string;
  renderer?: string;
}

/** Probe WebGL2 for GPU vendor/renderer telemetry in the perf diagnostic. */
export function probeWebGL2(canvas?: HTMLCanvasElement): WebGL2Status {
  const el = canvas ?? document.createElement("canvas");
  let gl: WebGL2RenderingContext | null = null;
  try {
    gl = el.getContext("webgl2", {
      alpha: false,
      antialias: true,
      powerPreference: "high-performance",
    });
  } catch {
    gl = null;
  }

  if (!gl) {
    return {
      ok: false,
      message: "WebGL2 is not available in this browser/context.",
    };
  }

  const dbg = gl.getExtension("WEBGL_debug_renderer_info");
  const vendor = dbg ? String(gl.getParameter(dbg.UNMASKED_VENDOR_WEBGL)) : undefined;
  const renderer = dbg ? String(gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL)) : undefined;

  return {
    ok: true,
    message: "WebGL2 ready",
    vendor,
    renderer,
  };
}
